<template>
  <!--<div class="flex flex-col border-b border-grey w-12">
    <div v-for="color in colors" class="w-12 h-12 border border-b-0 border-grey flex flex-row justify-center items-center">
      <div class="w-8 h-8" :style="{'background': color}"></div>
    </div>
  </div>-->
  <div class="flex flex-col shadow-md justify-center items-center p-2 mx-2 h-auto bg-white-dark">
    <div class="w-16 h-8 flex justify-center items-start font-bold" :class="[trueColors || normal ? '' : 'italic']">
      {{label}}
    </div>
    <div v-for="(color,index) in colors" 
         v-bind:key="index"
         class="w-16 h-16" 
         @click="toggleSelect(index)"
         :class="[trueColors ? 'swatch' : '', index === selectedIndex && trueColors ? 'selected' : '']" 
         :style="{'background': color}"></div>
  </div>
</template>

<<script>
export default {
  props: {
    colors: Array, 
    trueColors: Boolean, 
    normal: Boolean, 
    selectedIndex: Number, 
    label: String
  },
  methods: {
    toggleSelect(i) {
      this.$emit('select', i)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ColorColumn.vue?79bdb6ac